// import primary libraries
import React from 'react'
import PropTypes from 'prop-types'

const ProgressDots = ({ currentStep = 1, totalSteps }) => {
  const listItems = []
  for (let i = 1; i <= totalSteps; i++) {
    listItems.push(
      <li
        key={`progress_dot_${i}`}
        className={i <= currentStep ? 'active' : ''}
      ></li>,
    )
  }
  return <ul className="progress-dots">{listItems}</ul>
}

ProgressDots.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
}

export default ProgressDots
